import React from 'react';
import FormularioVentaForm, { FormularioVentaFormDocument } from '../../../components/FormularioVentaForm';
import { CotizacionVenta, CotizacionVentaDetalle } from '../../../services/cotizacionVentaService';
import { PedidoVentaDetalle } from '../../../services/pedidoVentaService';

export type CotizacionVentaUI = CotizacionVenta & {
  ordenCompra?: string;
  transporte?: string;
  ubicacion?: string;
  formaDePago?: string;
  nroSuc?: number;
  cuit?: string;
  tipoIVA?: string;
  dni?: string;
  idCompania?: string;
};

const mapDetalleToFormulario = (d: CotizacionVentaDetalle): PedidoVentaDetalle => ({
  nroIdformulario: d.nroIdformulario,
  nroItem: d.nroItem,
  codigoArticulo: d.codigoArticulo,
  descripcionArticulo: d.descripcionArticulo,
  cantidad: d.cantidad,
  precioUnitario: d.precioUnitario ?? d.precioLista,
  descuento: d.descuento ?? d.porcDesc,
  porcDesc: d.porcDesc,
  subtotal: d.subtotal,
  notas: d.notas,
  um: d.um,
  codigoMoneda: d.codigoMoneda,
  cotizacion: d.cotizacion,
});

const mapDetalleToCotizacion = (d: PedidoVentaDetalle): CotizacionVentaDetalle => ({
  nroIdformulario: d.nroIdformulario,
  nroItem: d.nroItem,
  codigoArticulo: d.codigoArticulo,
  descripcionArticulo: d.descripcionArticulo,
  cantidad: d.cantidad,
  precioUnitario: d.precioUnitario,
  precioLista: d.precioUnitario,
  descuento: d.descuento,
  porcDesc: d.porcDesc ?? d.descuento,
  subtotal: d.subtotal,
  notas: d.notas,
  um: d.um,
  codigoMoneda: d.codigoMoneda,
  cotizacion: d.cotizacion,
});

const toFormularioDocument = (c: CotizacionVentaUI): FormularioVentaFormDocument => ({
  ...c,
  codigoMoneda: typeof c.codigoMoneda === 'number' ? String(c.codigoMoneda) : (c.codigoMoneda ?? ''),
  nroTipoFormulario: '10',
  detalles: (c.detalles || []).map(mapDetalleToFormulario),
});

const toCotizacionVenta = (doc: FormularioVentaFormDocument): CotizacionVenta => ({
  ...doc,
  nroTipoFormulario: '10',
  detalles: (doc.detalles || []).map(mapDetalleToCotizacion),
});

export interface CotizacionFormProps {
  cotizacion: CotizacionVentaUI;
  onCotizacionChange: (cotizacion: CotizacionVenta) => void;
  onClienteSearch: () => void;
  onProductoSearch: () => void;
  onSave: () => void;
  loading: boolean;
  saveButtonText?: string;
  readOnly?: boolean;
}

const CotizacionForm: React.FC<CotizacionFormProps> = ({
  cotizacion,
  onCotizacionChange,
  onClienteSearch,
  onProductoSearch,
  onSave,
  loading,
  saveButtonText = 'Guardar Cotización',
  readOnly = false,
}) => {
  const document = toFormularioDocument(cotizacion);

  const handleChange = (doc: FormularioVentaFormDocument) => {
    onCotizacionChange(toCotizacionVenta(doc));
  };

  return (
    <FormularioVentaForm
      document={document}
      onChange={handleChange}
      onClienteSearch={onClienteSearch}
      onProductoSearch={onProductoSearch}
      onSave={onSave}
      loading={loading}
      saveButtonText={saveButtonText}
      readOnly={readOnly}
      tabLabelInfo="Información de la Cotización"
      tabLabelResumen="Resumen de la Cotización"
      ariaLabelTabs="pestañas de cotización"
    />
  );
};

export default CotizacionForm;
